//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopHeader from "./components/TopHeader/index";
import DebtTotal from "./components/DebtTotal/index";
import TrendTotal from "./components/TrendTotal/index";
import ProfitTotal from "./components/ProfitTotal/index";
import OldTotal from "./components/OldTotal/index";
import CostTotal from "./components/CostTotal/index";
import SalesGrossProfitTotal from "./components/SalesGrossProfitTotal/index";
import CategoryGrossProfitTotal from "./components/CategoryGrossProfitTotal/index";
import mixin from "@/mixins/index";
import dayjs from "dayjs";
import { getBossData } from "@/api/boss";
import "../../api/test";

export default {
  components: {
    TopHeader,
    DebtTotal,
    TrendTotal,
    ProfitTotal,
    OldTotal,
    CostTotal,
    SalesGrossProfitTotal,
    CategoryGrossProfitTotal,
  },
  name: "Boss",
  mixins: [mixin],
  data() {
    return {};
  },
  created() {
    getBossData().then((res) => {
      console.log(res);
    });
  },
  methods: {
    toDetail(type) {
      this.$router.push({ path: "/table", query: { type, date: this.date } });
    },
    initDate(date) {
      const now = dayjs(date).startOf("month");

      const dateList = [
        now.subtract(2, "month").format("YYYY-MM"),
        now.subtract(1, "month").format("YYYY-MM"),
        now.format("YYYY-MM"),
      ];
      this.$store.commit("setDateList", dateList);
      this.date = now.valueOf();
    },
  },
};
